import { ref, type Ref } from "vue";

export interface IBaseService {
  Get<T>(url: string, usetoken: boolean): Promise<T | ErrorResponse>;
  Post<T = void>(url: string, usetoken: boolean, payload: any): Promise<T | ErrorResponse>;
  Patch<T = void>(url: string, payload: any): Promise<T | ErrorResponse>;
  Delete(url: string): Promise<void | ErrorResponse>;

  Loading: Ref<boolean>;
}

export class ErrorResponse {
  message: string;
  success: boolean;
}

export class BaseService implements IBaseService {
  protected BaseUri: string;
  public Token?: string | null;
  private _loading: Ref<boolean>;

  constructor(baseUri: string, token?: string) {
    this.BaseUri = baseUri;
    this.Token = token;

    this._loading = ref<boolean>(false);
  }

  get Loading(): Ref<boolean> {
    return this._loading;
  }

  private async Execute<T>(url: string, method: string, useToken: boolean, payload?: any, returnBlob?: boolean): Promise<T | ErrorResponse> {
    const headers = new Headers();
    headers.append("Accept", "application/json");


    if (useToken && this.Token) {
      headers.append("Authorization", `Bearer ${this.Token}`);
    }

    if (payload) headers.append("Content-Type", "application/json");

    this._loading.value = true;

    try {

      const response = await fetch(`${this.BaseUri}${url}`, {
        method: method,
        cache: "no-cache",
        headers: headers,
        body: payload ? JSON.stringify(payload) : null,
      });

      if (!response.ok) {
        const text = await response.text();
        var result = JSON.parse(text) as ErrorResponse;

        var errorresult = new ErrorResponse();
        errorresult.message = result.message;
        return errorresult;
      }

      if (returnBlob) {
        return response.blob() as Promise<T>;
      }

      const text = await response.text();
      return text.length ? (JSON.parse(text) as Promise<T>) : null;
      
    } finally {
      this._loading.value = false;
    }
  }

  async Get<T>(url: string, usetoken: boolean, returnBlob?: boolean): Promise<T | ErrorResponse> {
    return this.Execute(url, "GET", usetoken, null, returnBlob);
  }

  async Post<T = void>(url: string, usetoken: boolean, payload: any, returnBlob?: boolean): Promise<T | ErrorResponse> {
    return this.Execute(url, "POST", usetoken, payload, returnBlob);
  }

  async Patch<T = void>(url: string, payload: any): Promise<T | ErrorResponse> {
    return this.Execute(url, "PATCH", true, payload);
  }

  async Delete(url: string): Promise<void | ErrorResponse> {
    return this.Execute(url, "DELETE", true);
  }
}